export class Constants {
  public static readonly HEX_START = '0x';
  public static readonly EMPTY_HEX_STRING = `${Constants.HEX_START}00`;
  public static readonly ETH_MAX_DECIMALS = 18;
}
